// VendorAuthorized.js

import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import axios from 'axios';
import config from '../config';

const VendorAuthorized = () => {
  const serverUrl = config.SERVER_URL;
  const { t } = useTranslation();
  const [cookies] = useCookies(['auth_token']);
  const [cookies1] = useCookies(['vendorID']);

  const [tenderDocuments, setTenderDocuments] = useState([]);
  const [data, setData] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const [vendorForm, setVendorForm] = useState({
    orgname: "",
    orgmobile: "",
    orgemail: "",
  });

  // NEW: Validation errors
  const [validationErrors, setValidationErrors] = useState({
    orgname: "",
    orgmobile: "",
    orgemail: ""
  });

  const navigate = useNavigate();
  let { id } = useParams();

  useEffect(() => {
    fetchTenderDocuments();
  }, []);

  const fetchTenderDocuments = async () => {
    try {
      const response = await axios.get(serverUrl + '/api/tender-documents/' + id);
      setTenderDocuments(response.data);
      setData(response.data);
    } catch (error) {
      console.error('Error fetching TenderDocuments:', error.message);
    }
  };

  const openVendorModal = (document) => {
    setSelectedDocument(document);
    setShowModal(true);
  };

  const submitVendorInfo = async () => {
    let errors = {};

    // Validation — orgname
    if (!vendorForm.orgname.trim()) {
      errors.orgname = t('orgname_required');
    }

    // Validation — orgmobile
    if (!vendorForm.orgmobile.trim()) {
      errors.orgmobile = t('org_mobile_required');
    } 

    // Validation — orgemail
    if (!vendorForm.orgemail.trim()) {
      errors.orgemail = t('org_email_required');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(vendorForm.orgemail)) {
      errors.orgemail = "Invalid email format";
    }

    // If errors exist → stop
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    // Clear errors
    setValidationErrors({ orgname: "", orgmobile: "", orgemail: "" });

    try {
      const payload = {
        orgname: vendorForm.orgname,
        orgmobile: vendorForm.orgmobile,
        orgemail: vendorForm.orgemail,
        tender_id: data?.id || tenderDocuments[0]?.id,
        //tender_doc_id: selectedDocument.tender_document_id,
      };

      const res = await axios.post(
        serverUrl + "/api/add_vendorinfo",
        payload
      );

      if (res.data.Result === "success") {
        setShowModal(false);
        downloadFile(selectedDocument.file, cookies.auth_token);
      } else {
        alert("Error saving vendor info");
      }
    } catch (err) {
      console.error(err);
      alert("Failed to submit vendor info");
    }
  };

  const downloadFile = (fileName, authToken) => {
    window.location.href = `${process.env.REACT_APP_SERVER}/api/files/${fileName}?auth_token=${authToken}`;
  };

  return (
    <div className="container">
      <br />
      <h2>{t('sbd_long')}</h2>
      <br />

      {tenderDocuments.length > 0 ? (
        <table className="table table-striped">
          <thead>
            <tr>
              <th>{t('tender_no')}</th>
              <th>{t('Refno')}</th>
              <th>{t('title')}</th>
              <th>{t('download')}</th>
            </tr>
          </thead>
          <tbody>
            {tenderDocuments.map((tender) => (
              <tr key={tender.tender_id}>
                <td>{tender.id}</td>
                <td>{tender.refno}</td>
                <td>{tender.title}</td>
                <td>
                  {Array.isArray(tender.documents) ? (
                    <ul>
                      {tender.documents.map((document) => (
                        <li key={document.tender_document_id}>
                          <button
                            className="btn btn-primary mt-2"
                            onClick={() => openVendorModal(document)}
                          >
                            {t('download')}{' '}
                          </button>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <ul>
                      {Object.values(tender.documents).map((document) => (
                        <li key={document.tender_document_id}>
                          <button
                            className="btn btn-primary mt-2"
                            onClick={() => openVendorModal(document)}
                          >
                            {t('download')}{' '}
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>{t('tender_not_found')}</p>
      )}

      {/* MODAL */}
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "#00000090" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">{t('vendor_information')}</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              <div className="modal-body">

                {/* ORG NAME */}
                <div className="mb-3">
                  <label>{t('vendor_org_name')}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={vendorForm.orgname}
                    onChange={(e) =>
                      setVendorForm({ ...vendorForm, orgname: e.target.value })
                    }
                  />
                  {/* ERROR */}
                  {validationErrors.orgname && (
                    <small className="text-danger">{validationErrors.orgname}</small>
                  )}
                </div>

                {/* MOBILE */}
                <div className="mb-3">
                  <label>{t('vendor_phone')}</label>
                  <input
                    type="number"
                    className="form-control"
                    value={vendorForm.orgmobile}
                    onChange={(e) =>
                      setVendorForm({ ...vendorForm, orgmobile: e.target.value })
                    }
                  />
                  {/* ERROR */}
                  {validationErrors.orgmobile && (
                    <small className="text-danger">{validationErrors.orgmobile}</small>
                  )}
                </div>

                {/* EMAIL */}
                <div className="mb-3">
                  <label>{t('vendor_email')}</label>
                  <input
                    type="email"
                    className="form-control"
                    value={vendorForm.orgemail}
                    onChange={(e) =>
                      setVendorForm({ ...vendorForm, orgemail: e.target.value })
                    }
                  />
                  {/* ERROR */}
                  {validationErrors.orgemail && (
                    <small className="text-danger">{validationErrors.orgemail}</small>
                  )}
                </div>

              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-primary"
                  onClick={submitVendorInfo}
                >
                  {t('vendor_submit')}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default VendorAuthorized;
